const sharedStyles = theme => ({
  listTitle: {
    width: '95%',
    margin: 'auto',
    padding: theme.spacing(3)
  },
  cardContainer: {
    width: '100%',
    textAlign: 'right',
    [theme.breakpoints.up('md')]: {
      width: '95%',
      textAlign: 'unset'
    }
  },
  listHeader: {
    margin: 0,
    background: 'none',
    boxShadow: 'none',
    fontSize: '0.8rem',
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'block'
    }
  },
  headerMobile: {
    display: 'inline-block',
    [theme.breakpoints.up('md')]: {
      display: 'none'
    }
  },
  headerContent: {
    paddingTop: 0,
    paddingBottom: 0
  },
  orderBy: {
    opacity: 0.6,
    padding: '4px 0',
    minWidth: 'unset',
    '&:hover': {
      background: 'none'
    },
    '&:focus': {
      background: 'none'
    }
  },
  itemCard: {
    margin: '12px 0',
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex'
    }
  },
  itemCardMobile: {
    display: 'flex',
    margin: 12,
    [theme.breakpoints.up('md')]: {
      display: 'none'
    }
  },
  viewButton: {
    borderColor: theme.palette.primary,
    borderWidth: '1px',
    borderStyle: 'solid',
    borderRadius: 0,
    padding: '4px 32px'
  },
  button: {
    color: '#fff'
  },
  largeText: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  }
});

export default sharedStyles;
